<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <CreateEditModeloPecaModal
      v-if="showCreateEditModeloPecaModal"
      :modeloPecaId="modeloPecaIdSelected"
      @closeModal="closeCreateEditModeloPecaModal"
    />
    <LoadingData v-if="loadData" />
    <div v-else class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom"
      >
        <h5 class="card-title mb-0">Modelos de Peças</h5>
        <div v-if="getModuleUserByCode('0.01.002')">
          <button
            type="button"
            class="btn btn-primary"
            title="Novo Usuário"
            @click="createEditModeloPeca()"
          >
            Novo Modelo de Peça
          </button>
        </div>
      </div>
      <div class="card-body">
        <ListModelosPecas
          :modelosPecas="modelosPecas"
          @editModeloPeca="createEditModeloPeca"
        />
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Layout from '@/views/layouts/Layout.vue'
import PageHeader from '@/components/commons/PageHeader.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import CreateEditModeloPecaModal from '@/components/projeto/modelos/peca/CreateEditModeloPecaModal.vue'
import ListModelosPecas from '../../../../components/projeto/modelos/peca/ListModelosPecas.vue'

export default {
  name: 'ModeloPeca',

  components: {
    Layout,
    PageHeader,
    CreateEditModeloPecaModal,
    LoadingData,
    ListModelosPecas,
  },

  data() {
    return {
      title: 'Modelo de Peças',
      items: [
        {
          text: 'Projeto',
        },
        {
          text: 'Modelos',
          active: true,
        },
        {
          text: 'Modelos de Peça',
          active: true,
        },
      ],
      loadData: true,
      showCreateEditModeloPecaModal: false,
      modelosPecas: null,
      modeloPecaIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['getModuleUserByCode']),
  },

  methods: {
    async getModelosPecas() {
      try {
        this.modelosPecas = await this.$store.dispatch('getModelosPecas')
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
      }
    },

    createEditModeloPeca(modeloPecaId) {
      this.modeloPecaIdSelected = modeloPecaId || null
      this.showCreateEditModeloPecaModal = true
    },

    closeCreateEditModeloPecaModal(loadListModelosPecas) {
      if (loadListModelosPecas) {
        this.getModelosPecas()
      }
      this.showCreateEditModeloPecaModal = false
    },
  },

  mounted() {
    this.getModelosPecas()
  },
}
</script>
